var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-transparent"},[_c('div',{class:[
      // Add margin bottom to avoid comment input hiding
      // content. 68px is the height of the comment input
      // field.
      _vm.shouldCommentInputStick && 'mb-[68px]',
    ]},_vm._l((_vm.commentList),function(comment,i){return _c('div',{key:comment.id,class:[_vm.commentBeingEditedId === comment.id ? 'mt-5' : 'mt-4', 'ps-3']},[_c('SurfacePostComment',{class:['relative', 'me-1.75', _vm.isLastComment(i) && 'mb-4'],attrs:{"id":comment.id,"comment":comment,"is-being-edited":_vm.commentBeingEditedId === comment.id,"usage-context":'postExpandedView'},on:{"show-comment-action-menu":function($event){return _vm.showCommentActionMenu({ commentId: comment.id })},"stop-editing":_vm.stopEditingComment,"edit":function($event){return _vm.editComment($event)}}}),_vm._v(" "),(!_vm.isLastComment(i))?_c('OzDivider',{staticClass:"ms-8 mt-4",attrs:{"color-scheme":_vm.OzDividerColorScheme.Solid}}):_vm._e()],1)}),0),_vm._v(" "),(_vm.isCommentable)?_c('div',{class:[
      _vm.shouldCommentInputStick
        ? [
            'absolute',
            // When using absolute, we need to explicitly set
            // the width. 24px are the margins on both sides.
            'w-[calc(100vw-24px)]',
          ]
        : 'sticky',
      'bottom-0',
      'pt-4 pb-3',
      'bg-light-ui-100 dark:bg-dark-ui-100',
    ]},[_c('div',{staticClass:"flex items-end"},[_c('div',{class:[
          'flex-grow',
          'flex justify-start',
          'border-2 border-solid rounded-2xl',
          'border-dark-text-200 dark:border-light-text-200',
          'focus-within:border-grape-500 dark:focus-within:border-canary-500',
          'min-h-[21px]',
          'ps-2.5 pe-1.5 pt-1.75 pb-2',
        ],style:({
          // Safari has a weird bug with the input text field border
          // whenever we show/hide the Add comment button.
          // (See: https://github.com/padlet/mozart/pull/9132)
          // Using 'will-change: transform' fixes this.
          willChange: 'transform',
        })},[_c('OzAvatar',{staticClass:"me-4 rounded-full",attrs:{"src":_vm.user.avatar,"width":20,"height":20,"alt-text-name":_vm.user.name || _vm.user.username}}),_vm._v(" "),_c('div',{staticClass:"flex-grow"},[_c('MultilineInput',{ref:"addCommentInput",class:[
              'transition-none',
              'm-0',
              'text-body-small-posts',
              'font-sans',
              'text-dark-text-100 dark:text-light-text-100',
              'placeholder-dark-text-200 dark:placeholder-light-text-200',
            ],attrs:{"autocomplete":"off","value":_vm.newCommentBody,"placeholder":_vm.__('Add comment'),"title":_vm.__('Add comment'),"aria-label":_vm.__('Add comment'),"auto-height":false},on:{"focus":_vm.onAddCommentFocus,"blur":_vm.onAddCommentBlur,"input":_vm.onAddCommentInput,"enter":_vm.publishComment},nativeOn:{"paste":function($event){$event.stopPropagation();}}})],1)],1),_vm._v(" "),(_vm.newCommentBody)?_c('OzIconButton',{staticClass:"flex-shrink-0 ms-2.5",attrs:{"dark-mode":_vm.darkMode,"color-scheme":_vm.OzIconButtonColorScheme.Primary,"icon-name":'arrow_right',"icon-size":16,"size-preset":_vm.OzIconButtonSizePreset.H40px,"label":_vm.__('Add comment')},on:{"click":_vm.publishComment}}):_vm._e()],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }